exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_slides_1BWstQw-Tr-5yQ2f81rQl9 {\n  position: relative;\n  width: 100%;\n  height: auto;\n  float: left;\n}\n\n.IA_filters_29N0bBKBVloAhC-EPUmwoL {\n  width: 100%;\n  margin-bottom: 10px;\n  display: flex;\n  flex-direction: row;\n}\n\n.IA_paginationButtonContainer_3Gs0R7cw_1c0jkXxKIGvSQ {\n  width: 100%;\n  height: 30px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  margin-top: 20px;\n}\n\n.IA_paginationPageCount_3lqnCbekTmeVFWHHMslrRP {\n  text-align: center;\n}", ""]);

// Exports
exports.locals = {
	"IA_slides": "IA_slides_1BWstQw-Tr-5yQ2f81rQl9",
	"IA_filters": "IA_filters_29N0bBKBVloAhC-EPUmwoL",
	"IA_paginationButtonContainer": "IA_paginationButtonContainer_3Gs0R7cw_1c0jkXxKIGvSQ",
	"IA_paginationPageCount": "IA_paginationPageCount_3lqnCbekTmeVFWHHMslrRP"
};